import React, { useMemo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ScrollIndicatorContainer from '../../../components/ScrollIndicatorContainer';
import InternationalCard from './InternationalCard';
import { getInternationalSectionStyles } from './InternationalSectionCss';

/**
 * Renders a single market section (e.g. "US Stocks") with a
 * horizontal scrollable row of InternationalCard components.
 *
 * @param {string} props.title    - Section heading label
 * @param {Array}  props.instruments - Array of instrument objects from API
 */
const InternationalSection = ({ title, instruments }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const styles = useMemo(() => getInternationalSectionStyles(theme, isDark), [theme, isDark]);

  return (
    <Box sx={styles.wrapper}>
      <Typography variant="h6" sx={styles.titleText}>
        {title}
      </Typography>

      {(!instruments || instruments.length === 0) ? (
        <Box sx={styles.emptyState}>
          <Typography sx={styles.emptyText}>No data available</Typography>
        </Box>
      ) : (
        <ScrollIndicatorContainer sx={styles.scrollContainer}>
          {instruments.map((instrument) => (
            <InternationalCard
              key={`${instrument.exchange}-${instrument.token}`}
              instrument={instrument}
            />
          ))}
        </ScrollIndicatorContainer>
      )}
    </Box>
  );
};

export default React.memo(InternationalSection);
